import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import styles from "./ResourceDetailPage.module.css";

const ResourceDetailPage = () => {
  const { id } = useParams();
  const [likeCount, setLikeCount] = useState(48);
  const [liked, setLiked] = useState(false);

  // 실제 구현에서는 id를 기반으로 API에서 데이터를 가져올 것입니다
  // 여기서는 샘플 데이터를 사용합니다
  const resourceDetail = {
    id: 1,
    title: "4월 넷째주 주식시황 및 전망",
    category: "주식시황",
    author: "관리자",
    date: "2025-04-20",
    views: 245,
    likes: likeCount,
    content: `
      <p>이번주 주요 시장 동향🚩</p>
      <p>이번 주 글로벌 증시는 미국 고용지표와 인플레이션 데이터에 주목하며 변동성을 보였습니다. S&P 500 지수는 주초 하락세를 보였으나, 예상보다 낮은 인플레이션 수치 발표 이후 반등하여 주간 상승세로 마감했습니다.</p>
      
      <p>국내 시장 분석🗒</p>
      <p>국내 증시는 외국인 투자자들의 순매수 흐름 속에서 기술주를 중심으로 상승세를 보였습니다. 특히 반도체 관련주는 글로벌 AI 수요 증가 전망에 힘입어 강세를 보였습니다.</p>
      
      <p>업종별 동향📊</p>
      <p> ● IT/반도체: 주간 5.2% 상승</p>
      <p> ● 금융: 주간 2.1% 상승</p>
      <p> ● 바이오/제약: 주간 1.7% 상승</p>
      <p> ● 화학/철강: 주간 0.5% 하락</p>
      
      <p>다음주 전망 및 투자 전략📑</p>
      <p>다음 주에는 미국 FOMC 회의록 발표와 주요 기업들의 실적 발표가 예정되어 있어, 이에 따른 시장 변동성이 예상됩니다. 단기적으로는 실적 발표에 따른 개별주 장세가 이어질 것으로 전망되며, 특히 기대 이상의 실적을 발표하는 기업들에 대한 관심이 필요해 보입니다.</p>
      
      <p>투자 전략으로는 다음과 같은 포인트에 주목할 필요가 있습니다:</p>
      <p> 1. AI 관련 수혜주에 대한 지속적인 모니터링</p>
      <p> 2. 금리 동향에 따른 금융주 비중 조절</p>
      <p> 3. 실적 시즌에 따른 개별주 접근 전략</p>
      
      <p>주목해야 할 종목💡</p>
      <p>다음 주 주목해볼 만한 종목으로는 실적 개선이 예상되는 IT 대형주와 수출 회복세의 수혜가 예상되는 자동차 및 부품 관련주가 있습니다. 또한, 금리 인하 기대감에 따른 고배당 우량주에도 관심을 가질 필요가 있습니다.</p>
    `,
    attachments: [
      { id: 1, name: "4월_넷째주_주식시황_분석자료.pdf", size: "2.4MB" },
      { id: 2, name: "업종별_실적전망_데이터.xlsx", size: "1.8MB" },
    ],
    relatedResources: [
      {
        id: 5,
        title: "미국 금리 인상에 따른 시장 영향 분석",
        date: "2025-04-08",
      },
      { id: 3, title: "반도체 관련주 심층 분석", date: "2025-04-15" },
    ],
  };

  const handleLike = () => {
    if (liked) {
      setLikeCount((prev) => prev - 1);
    } else {
      setLikeCount((prev) => prev + 1);
    }
    setLiked(!liked);
  };

  // HTML 콘텐츠를 안전하게 렌더링하기 위한 함수
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.mainContent}>
          <div className={styles.resourceNav}>
            <Link to="/resources" className={styles.backLink}>
              ← 자료실 목록으로
            </Link>
          </div>

          <div className={styles.resourceHeader}>
            <div className={styles.resourceMeta}>
              <span className={styles.resourceCategory}>
                {resourceDetail.category}
              </span>
              <h1 className={styles.resourceTitle}>{resourceDetail.title}</h1>
              <div className={styles.resourceInfo}>
                <span className={styles.author}>{resourceDetail.author}</span>
                <span className={styles.separator}>•</span>
                <span className={styles.date}>{resourceDetail.date}</span>
                <span className={styles.separator}>•</span>
                <span className={styles.views}>
                  조회 {resourceDetail.views}
                </span>
              </div>
            </div>

            <div className={styles.resourceActions}>
              <button
                className={`${styles.likeButton} ${liked ? styles.liked : ""}`}
                onClick={handleLike}
              >
                {liked ? "👍 좋아요 취소" : "👍 좋아요"} ({resourceDetail.likes}
                )
              </button>
            </div>
          </div>

          <div className={styles.divider}></div>

          <div
            className={styles.resourceContent}
            dangerouslySetInnerHTML={createMarkup(resourceDetail.content)}
          ></div>
          <div className={styles.divider}></div>

          {resourceDetail.attachments.length > 0 && (
            <div className={styles.attachmentsSection}>
              <h3 className={styles.sectionTitle}>첨부파일</h3>
              <div className={styles.attachmentsList}>
                {resourceDetail.attachments.map((attachment) => (
                  <div key={attachment.id} className={styles.attachmentItem}>
                    <span className={styles.attachmentIcon}>📎</span>
                    <span className={styles.attachmentName}>
                      {attachment.name}
                    </span>
                    <span className={styles.attachmentSize}>
                      {attachment.size}
                    </span>
                    <button className={styles.downloadButton}>다운로드</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {resourceDetail.relatedResources.length > 0 && (
            <div className={styles.relatedSection}>
              <h3 className={styles.sectionTitle}>관련 자료</h3>
              <div className={styles.relatedList}>
                {resourceDetail.relatedResources.map((related) => (
                  <Link
                    key={related.id}
                    to={`/resources/${related.id}`}
                    className={styles.relatedItem}
                  >
                    <span className={styles.relatedTitle}>{related.title}</span>
                    <span className={styles.relatedDate}>{related.date}</span>
                  </Link>
                ))}
              </div>
            </div>
          )}

          <div className={styles.resourceFooter}>
            <Link to="/resources" className={styles.listButton}>
              목록으로
            </Link>
            <div>
              <button className={styles.actionButton}>수정</button>
              <button className={styles.actionButton}>삭제</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceDetailPage;
